/**
 * HAT-1173: הסינון נשאר כמו שהיה — קידומת על מספר הקופה או מחרוזת בשם.
 * הדירוג מבטיח שקופה 5 תופיע ראשונה כשמקלידים "5", לפני 50 / 51 / 500.
 */

export const FUND_PICKER_MATCH_LIMIT = 8;

export type FundPickerMatch = {
  id: number | string;
  name: string;
};

/**
 * דירוג סופי (לא Infinity) להתאמות שם בלבד, כדי שה-comparator לעולם לא יחזיר NaN
 * (Infinity - Infinity) וה-tie-break לפי סדר הקטלוג יופעל בפועל.
 */
const NAME_ONLY_RANK = Number.MAX_SAFE_INTEGER;

/** התאמה מדויקת למספר, אחר כך קידומות קצרות יותר, ואחר כך התאמות שם בלבד. */
function idRank(id: string, query: string): number {
  if (id === query) return 0;
  if (id.startsWith(query)) return id.length;
  return NAME_ONLY_RANK;
}

/**
 * מסנן את הקטלוג ומחזיר עד `limit` תוצאות לתיבת הבחירה, מדורגות לפי מספר הקופה.
 * סדר המשני יציב: סדר הקטלוג המקורי נשמר בין פריטים באותו דירוג.
 */
export function filterAndRankFundPickerMatches<T extends FundPickerMatch>(funds: T[], query: string, limit = FUND_PICKER_MATCH_LIMIT): T[] {
  const trimmed = query.trim();
  if (!trimmed) return [];

  const q = trimmed.toLowerCase();
  const matched: { fund: T; index: number; rank: number }[] = [];
  funds.forEach((fund, index) => {
    const id = String(fund.id);
    if (id.startsWith(trimmed) || (fund.name ?? '').toLowerCase().includes(q)) {
      matched.push({ fund, index, rank: idRank(id, trimmed) });
    }
  });

  matched.sort((a, b) => a.rank - b.rank || a.index - b.index);

  return matched.slice(0, limit).map(({ fund }) => fund);
}
